/* MSPO Expert Advice page: click-to-play YouTube player, Shorts rails, topic chips.
   Loaded by every mspo-ea-* section; runs once. Builds DOM with createElement only
   (Shopify's HTML rewriter breaks "<img" inside inline JS strings). */
(function () {
  if (window.__mspoEA) return;
  window.__mspoEA = true;

  var dialog, frameBox, titleEl, capEl, metaEl, ytLink, relLink, lastTrigger;

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function buildDialog() {
    dialog = el('dialog', 'mspo-ea-player', { 'aria-label': 'Video player' });
    var inner = el('div', 'mspo-ea-player__inner');
    var close = el('button', 'mspo-ea-player__close', { type: 'button', 'aria-label': 'Close video' });
    close.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    close.addEventListener('click', closePlayer);
    frameBox = el('div', 'mspo-ea-player__frame');
    var bar = el('div', 'mspo-ea-player__bar');
    titleEl = el('p', 'mspo-ea-player__title');
    var links = el('p', 'mspo-ea-player__links');
    relLink = el('a', 'button mspo-ea-player__rel');
    ytLink = el('a', 'mspo-ea-player__yt', { target: '_blank', rel: 'noopener' });
    ytLink.textContent = 'Watch on YouTube';
    links.appendChild(relLink);
    links.appendChild(ytLink);
    capEl = el('p', 'mspo-ea-player__cap');
    metaEl = el('p', 'mspo-ea-player__meta');
    bar.appendChild(titleEl);
    bar.appendChild(links);
    bar.appendChild(capEl);
    bar.appendChild(metaEl);
    inner.appendChild(close);
    inner.appendChild(frameBox);
    inner.appendChild(bar);
    dialog.appendChild(inner);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closePlayer(); });
    dialog.addEventListener('close', teardown);
    document.body.appendChild(dialog);
  }

  function openPlayer(btn) {
    if (!dialog) buildDialog();
    lastTrigger = btn;
    var id = btn.getAttribute('data-mspo-yt');
    var isShort = btn.getAttribute('data-format') === 'short';
    var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    dialog.classList.toggle('is-short', isShort);
    titleEl.textContent = btn.getAttribute('data-title') || '';
    capEl.textContent = btn.getAttribute('data-caption') || '';
    capEl.hidden = !capEl.textContent;
    metaEl.textContent = btn.getAttribute('data-meta') || '';
    metaEl.hidden = !metaEl.textContent;
    ytLink.href = btn.getAttribute('data-watch') || ('https://www.youtube.com/watch?v=' + id);
    var ru = btn.getAttribute('data-related-url');
    if (ru) {
      relLink.href = ru;
      relLink.textContent = btn.getAttribute('data-related-label') || 'Shop related parts';
      relLink.hidden = false;
    } else {
      relLink.hidden = true;
    }
    frameBox.textContent = '';
    var ifr = el('iframe', '', {
      src: src,
      title: btn.getAttribute('data-title') || 'YouTube video',
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      allowfullscreen: '',
      referrerpolicy: 'strict-origin-when-cross-origin'
    });
    frameBox.appendChild(ifr);
    // A head script on this store strips iframe src on some platforms; put it back.
    setTimeout(function () { if (!ifr.getAttribute('src')) ifr.setAttribute('src', src); }, 60);
    setTimeout(function () { if (!ifr.getAttribute('src')) ifr.setAttribute('src', src); }, 400);
    document.documentElement.classList.add('mspo-ea-lock');
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  }

  function teardown() {
    if (frameBox) frameBox.textContent = '';
    document.documentElement.classList.remove('mspo-ea-lock');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  function closePlayer() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
    // Don't wait for the async 'close' event: stop the video and unlock scrolling now.
    teardown();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mspo-yt]');
    if (!btn) return;
    // ctrl/cmd/shift/middle clicks keep their normal "open YouTube" behavior
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    openPlayer(btn);
  });

  /* Shorts rails: arrow buttons on wide screens, native swipe on phones. */
  function initRail(rail) {
    var track = rail.querySelector('.mspo-ea-rail__track');
    var prev = rail.querySelector('.mspo-ea-rail__btn--prev');
    var next = rail.querySelector('.mspo-ea-rail__btn--next');
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var scrollable = max > 4;
      prev.hidden = !scrollable || track.scrollLeft <= 2;
      next.hidden = !scrollable || track.scrollLeft >= max;
    }
    function go(dir) {
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.85, 200), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Topic chips: built from the topic sections actually on the page, so the owner
     never has to keep a second list in sync. */
  function initChips() {
    var boxes = document.querySelectorAll('[data-mspo-chips]');
    if (!boxes.length) return;
    var topics = document.querySelectorAll('[data-mspo-topic]');
    boxes.forEach(function (box) {
      box.textContent = '';
      topics.forEach(function (t) {
        if (!t.id) return;
        var a = el('a', 'mspo-ea-chip', { href: '#' + t.id });
        a.textContent = t.getAttribute('data-topic-label') || t.id;
        var c = t.getAttribute('data-topic-count');
        if (c && c !== '0') {
          var s = el('span', 'mspo-ea-chip__n');
          s.textContent = c;
          a.appendChild(s);
        }
        box.appendChild(a);
      });
      box.hidden = !box.children.length;
    });
  }

  /* Keep anchor jumps and the sticky contents clear of the theme's sticky header. */
  function headerOffset() {
    var max = 0;
    document.querySelectorAll('header, .shopify-section-group-header-group, sticky-header, .header-section').forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = h.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > max && r.bottom < innerHeight / 2) max = r.bottom;
      }
    });
    document.documentElement.style.setProperty('--mspo-ea-top', Math.round(max + 16) + 'px');
  }

  /* Highlight the guide topic currently being read. */
  function initToc() {
    var toc = document.querySelector('[data-mspo-toc]');
    if (!toc || !('IntersectionObserver' in window)) return;
    var links = {};
    toc.querySelectorAll('a[href^="#"]').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && links[en.target.id]) {
          if (current) current.classList.remove('is-active');
          current = links[en.target.id];
          current.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    Object.keys(links).forEach(function (id) { var t = document.getElementById(id); if (t) io.observe(t); });
  }

  function init() {
    headerOffset();
    window.addEventListener('resize', headerOffset);
    document.querySelectorAll('[data-mspo-rail]').forEach(initRail);
    initChips();
    initToc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mspo-rail]').forEach(initRail);
    initChips();
  });
})();
